export default function (app, inject) {
  inject('scroll', node => {
    const isPreferReducedMotion = Boolean(
      window.matchMedia('(prefers-reduced-motion: reduce)')?.matches
    )

    // TODO: Improve
    const element =
      typeof node === 'string' ? document.querySelector(node) : node
    const isDesktop = window.innerWidth >= 768
    const offset = isDesktop ? 0 : 48

    if (element) {
      window.scrollTo({
        top: element.offsetTop - offset,
        left: 0,
        behavior: isPreferReducedMotion ? 'auto' : 'smooth'
      })
    }
  })
}
